export default __webpack_public_path__ + "static/char-s-35-ja-e2ca42d617a717aa4a0b943d908c9868.png";